import { render, staticRenderFns } from "./JacNatconZoneAwardList.vue?vue&type=template&id=84970074"
import script from "./JacNatconZoneAwardList.vue?vue&type=script&lang=js"
export * from "./JacNatconZoneAwardList.vue?vue&type=script&lang=js"
import style0 from "./JacNatconZoneAwardList.vue?vue&type=style&index=0&id=84970074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports